export default __webpack_public_path__ + "static/media/internet.e5f4fe6c.svg";